import { toValue as t, ref as h, watch as d, onScopeDispose as m, computed as u } from "vue";
const s = /* @__PURE__ */ new Map();
function f(e) {
  s.has(t(e)) || s.set(t(e), {
    hasMatches: h(!1),
    mediaQueryList: window.matchMedia(t(e))
  });
  const a = s.get(t(e));
  function n(i) {
    a.hasMatches.value = i.matches;
  }
  function c() {
    var i;
    typeof ((i = a.mediaQueryList) == null ? void 0 : i.removeEventListener) == "function" && a.mediaQueryList.removeEventListener("change", n);
  }
  const o = d(
    () => t(e),
    () => {
      c(), a.mediaQueryList = window.matchMedia(t(e)), a.mediaQueryList.addEventListener("change", n), a.hasMatches.value = a.mediaQueryList.matches;
    },
    { immediate: !0 }
  );
  return m(() => {
    o(), c(), s.delete(t(e));
  }), u(() => {
    var i;
    return !!((i = s.get(t(e))) != null && i.hasMatches.value);
  });
}
export {
  f as default
};
//# sourceMappingURL=useMediaQuery.js.map
